module.exports = __webpack_public_path__ + "img/electronic_reserved.af9a3c05.svg";